// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"144c9b61","703":"aae0b796"}[chunkId] + ".chunk.js";
};